
export default class FormFactory {
  constructor(props) {
  
    this.changedInputs = [];
  }

  init (){
    this.changedInputs = [];
  }

  jsonifyInputs(arrList) {
    var result= {};
    arrList.forEach(element => {
      const field = this.findChange (element);
      if (field !== null)
        result[field.property] = field.value;
    });
    return result;
  }

  jsonifyIndexed(arrList, index) {
    var result= {};
    arrList.forEach(element => {
      const field = this.findNumberedChange (element, index);
      if (field !== null)
        result[field.property] = field.value;
    });
    return result;
  }
  
  handleChange = event => {
    const item = event.target
    const stateData = {property:item.id, value: item.value, ...(item.dataset?.seq && {seq: item.dataset.seq}) }
    const changedIndex = item.dataset?.seq ? this.findNumberedChangeIndex(item.id, item.dataset.seq) : 
      this.findChangeIndex(item.id)
    let temp = this.changedInputs.slice(0);
    changedIndex >= 0 ? temp[changedIndex] = stateData : temp.push(stateData);
    this.changedInputs =temp
  }

  addInitialChange(id, value){
    const stateData = {property:id, value: value,};
    let temp = this.changedInputs.slice(0);
    temp.push(stateData);
    this.changedInputs =temp
  }
  replace (id, value) {
    const i = this.findChangeIndex(id)
    if (i > -1) {
      this.changedInputs[i] = {property:id, value: value,}
    }
    else
      this.addInitialChange (id, value)
  }
  findChange(id) {
    const changedIndex = this.findChangeIndex(id);
    return changedIndex >= 0 ? this.changedInputs[changedIndex] : null;
  }

  findChangeIndex(id) {
    return this.changedInputs.findIndex(item => item.property === id)  
  }

  findNumberedChange(id, index) {
    const changedIndex = this.findNumberedChangeIndex(id, index);
    return changedIndex >=0 ? this.changedInputs[changedIndex] : null;
  }

  findNumberedChangeIndex(id, index) {
    return this.changedInputs.findIndex(item => item.property === id && item?.seq === index)
  }
  isBlank (id) {
    const field = this.findChange(id);
    return (field===null || field.value?.trim().length === 0)
  }
}

